<div class="d-flex flex-column align-items-center justify-content-center gap-5">
  <p-stepper-header
    class="w-100"
    [steps]="stepLabels"
    [currentStepIndex]="currentStepIndex"
  ></p-stepper-header>

  <div class="stepper-content-and-footer w-75 shadow">
    <div class="stepper-content w-100" *ngIf="currentStep as step">
      <ng-container [ngComponentOutlet]="step.component"></ng-container>
    </div>

    <div class="d-flex justify-content-end my-5 px-5 gap-3">
      <p-button
        *ngIf="!currentStep?.isFirstStep"
        class="button"
        id="btn-commander"
        [label]="currentStep?.previousButton"
        level="secondary"
        [disabled]="!canGoPrevious"
        (click)="previous()"
        [width]="100"
      ></p-button>

      <p-button
        *ngIf="!currentStep?.isFinalStep"
        class="button"
        id="btn-commander"
        [label]="currentStep?.nextButton"
        level="primary"
        [disabled]="!canGoNext || disableNextButton"
        (click)="next()"
        [width]="100"
      ></p-button>
      <div
        *ngIf="currentStep?.isFinalStep"
        class="d-flex align-items-center gap-2"
      >
        <p-button
          class="button"
          id="btn-commander"
          [label]="currentStep?.nextButton"
          level="primary"
          (click)="confirmed()"
          [width]="100"
          [disabled]="disableNextButton"
        ></p-button>
      </div>
    </div>
  </div>
</div>
